import { GreenroomInviteUser, GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';
import { Post } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const SendGreenroomInvite = async (payload: GreenroomInviteUser): Promise<GreenroomInviteUserResponse[]> => {
  return Post({
    host: GREENROOM_HOST,
    url: '/v3/greenroom/create-invitations?unified_auth=1',
    body: payload,
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default SendGreenroomInvite;
